"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _ParticipationStatement = _interopRequireDefault(require("../../../../articles/ParticipationStatement"));
var _link = _interopRequireDefault(require("../../../../core/link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Welcome to the online entry system for canoe slalom. We hope you enjoy your event.");
var _ref2 = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Welcome to canoe slalom and online entries. We hope you will enjoy competing in our sport."), /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement("span", null, "Click Accept below, to confirm that you accept our", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "https://canoeslalomentries.co.uk/articles/terms",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Terms"), ' and ', /*#__PURE__*/_react.default.createElement("a", {
  href: "https://canoeslalomentries.co.uk/articles/privacy",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Privacy Policy"), ' ', "and to confirm that that the participant(s) entered above and their guardians (where the paddler is under 18) understand and accept the \"Participation Statement\".")), /*#__PURE__*/_react.default.createElement(_ParticipationStatement.default, null));
class TsAndCs extends _react.Component {
  render() {
    let bibName = this.props.existingPaddler1 && this.props.existingPaddler1.paddlerName || this.props.paddler1.newFromScratch.paddlerName;
    if (this.props.isPair) {
      const paddler2Name = this.props.existingPaddler2 && this.props.existingPaddler2.paddlerName || this.props.paddler2.newFromScratch.paddlerName;
      bibName = bibName + ' / ' + paddler2Name;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, bibName), this.props.isNonPaddler ? _ref : _ref2);
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  paddlerName: true
};
var _ref4 = {
  paddlerName: true
};
var _ref5 = {
  paddlerName: true
};
var _ref6 = {
  paddlerName: true
};
var _default = exports.default = (0, _reactBicycle.connect)(TsAndCs, props => {
  if (props.paddler1.newFromExisting.existingPaddlerID && props.paddler2.newFromExisting.existingPaddlerID) {
    return {
      ["paddlerByID(paddlerID:" + JSON.stringify(props.paddler1.newFromExisting.existingPaddlerID) + ") as existingPaddler1"]: _ref3,
      ["paddlerByID(paddlerID:" + JSON.stringify(props.paddler2.newFromExisting.existingPaddlerID) + ") as existingPaddler2"]: _ref4
    };
  }
  if (props.paddler1.newFromExisting.existingPaddlerID) {
    return {
      ["paddlerByID(paddlerID:" + JSON.stringify(props.paddler1.newFromExisting.existingPaddlerID) + ") as existingPaddler1"]: _ref5
    };
  }
  if (props.paddler2.newFromExisting.existingPaddlerID) {
    return {
      ["paddlerByID(paddlerID:" + JSON.stringify(props.paddler2.newFromExisting.existingPaddlerID) + ") as existingPaddler2"]: _ref6
    };
  }
  return;
});